import React from 'react'

import { Charts, FactSources, LastUpdate } from 'modules/Charts/components'
import { useCharts } from 'modules/Charts/serviceHooks'
import { ConditionRender, Layout } from 'components'

const ChartsContainer = () => {
  const { chartRows, factSources, assignedСampaigns, chartsLoading } = useCharts()

  return (
    <ConditionRender
      condition={!!factSources.length && !!chartRows.length && !chartsLoading}
      component={
        <Layout>
          <div className="charts">
            <FactSources factSources={factSources} />
            <LastUpdate charts={chartRows} factSources={factSources} />
            <Charts charts={chartRows} factSources={factSources} {...(assignedСampaigns && { assignedСampaigns })} />
          </div>
        </Layout>
      }
    />
  )
}

export default ChartsContainer
